// Ausschließlich Typimporte: diese Datei ist eifrig erreichbar (Interceptor und
// MsalB2CService hängen daran), und ein Wertimport aus @azure/msal-* zöge das Paket ins
// initiale Bundle. `interactionType` stand hier früher als Wert - InteractionType ist ein
// echtes TypeScript-enum und damit Laufzeitcode. Es ist nach msal-auth.providers der Apps
// gewandert, also dorthin, wo MSAL ohnehin geladen ist; dadurch braucht es keinen Cast.
import type { ProtectedResourceScopes } from "@azure/msal-angular";
import type { HandleRedirectPromiseOptions } from "@azure/msal-browser";
import { GlobalTranslationVar } from "@commonClass/GlobalTranslationVar";
import { Language } from "@commonEnums/language";
import { isNullishOrEmpty } from "@commonHelpers/math-utils";
import { environment } from "@environments/environment";

// Bis msal-browser 4 war navigateToLoginRequestUrl eine globale Option der PublicClientApplication
// und galt damit für jede Verarbeitung einer Redirect-Antwort. Ab msal-browser 5 ist sie Teil des
// einzelnen handleRedirectPromise-Aufrufs. Beide Apps hatten `true` konfiguriert; der Wert wird
// deshalb an jeder Aufrufstelle explizit übergeben statt sich auf einen Standardwert zu verlassen,
// den die Typdefinition nicht zusichert.
export const handleRedirectOptions: HandleRedirectPromiseOptions = { navigateToLoginRequestUrl: true };
export const baseAuthority = "https://" + environment.msal.tenant + ".b2clogin.com/" + environment.msal.tenant + ".onmicrosoft.com/";
export const signinAuthority = baseAuthority + environment.msal.signInFlow;
export const scopes = [`https://${environment.msal.tenant}.onmicrosoft.com/${environment.msal.middlewareAppIdUriSuffix}/${environment.msal.apiAccessScope}`];


export const protectedResourceMap = (apiAccesses: string[]): Map<string, (string | ProtectedResourceScopes)[] | null> => {
	const resourceMap = new Map<string, (string | ProtectedResourceScopes)[] | null>();

	// Nicht konfigurierte Api-Adressen werden verworfen: Ein leerer Key würde beim Präfixvergleich
	// der Interceptoren auf jede relative Url passen und das Zugriffstoken an fremde Requests hängen.
	const configuredApiAccesses = apiAccesses.filter(apiAccess => !isNullishOrEmpty(apiAccess));

	for (const apiAccess of configuredApiAccesses) {
		resourceMap.set(apiAccess, scopes);
	}

	return resourceMap

}

export const loginLanguage = () => {
	const onboardingLanguageFromUrl = new URLSearchParams(window.location.search).get("language");
	switch (onboardingLanguageFromUrl) {
		case 'German': return Language.DE
		case 'English': return Language.EN
	}
	return GlobalTranslationVar.SELECTED_LANGUAGE === Language.DE ? Language.DE : Language.EN
};
